var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"id":_vm.id,"disabled":Boolean(_vm.aktif),"label":_vm.etiket,"name":_vm.name,"autocomplete":_vm.autocomplete},on:{"blur":function($event){_vm.isInputActive=false},"focus":function($event){_vm.isInputActive=true}},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }